@if (appointmentDto && patientDto) {
  <div class="page-column">
    <div class="title">
      <app-icon-button (click)="back()" colorVariant="secondary-dark" icon="arrow_back" size="small"/>
      <div class="typo-h2">{{ "profile.appointmentDetails.title" | transloco }}</div>
    </div>

    <div class="column">
      <div class="body-text-bold">{{ "profile.appointmentDetails.label.appointment" | transloco }}</div>
      <div class="info-card">
        <div class="info-line">
          <div class="body-text-small-bold label">
            {{ "profile.appointmentDetails.label.date" | transloco }}
          </div>

          <div class="body-text">
            {{ appointmentDto.startTime | customDate:'dd.MM.yyyy' }}
          </div>
        </div>

        <div class="info-line">
          <div class="body-text-small-bold label">
            {{ "profile.appointmentDetails.label.time" | transloco }}
          </div>

          <div class="body-text">
            {{ appointmentDto.startTime | customDate:'HH:mm' }} - {{ appointmentDto.endTime | customDate:'HH:mm' }}
          </div>
        </div>

        <div class="info-line">
          <div class="body-text-small-bold label">
            {{ "profile.appointmentDetails.label.patient" | transloco }}
          </div>

          <div class="body-text">
            {{ patientDto.firstName }} {{ patientDto.lastName }}
          </div>
        </div>

        <div class="info-line">
          <div class="body-text-small-bold label">
            {{ "profile.appointmentDetails.label.appointmentType" | transloco }}
          </div>

          <div class="body-text">
            {{ appointmentDto | appointmentType }}
          </div>
        </div>
      </div>
    </div>

    @if (locationDetailDto) {
      <div class="column">
        <div class="body-text-bold">{{ "profile.appointmentDetails.label.practise" | transloco }}</div>
        <div class="info-card">
          <div class="info-line">
            <div class="body-text-small-bold label">
              {{ "profile.appointmentDetails.label.address" | transloco }}
            </div>

            <div class="body-text">
              {{ locationDetailDto.name }}
              <br>
              {{ locationDetailDto.contact.street }}
              <br>
              {{ locationDetailDto.contact.zipCode }} {{ locationDetailDto.contact.city }}
            </div>
          </div>

          <div class="info-line">
            <div class="body-text-small-bold label">
              {{ "profile.appointmentDetails.label.phone" | transloco }}
            </div>

            <div class="body-text">
              {{ locationDetailDto.contact.phone }}
            </div>
          </div>

          <div class="info-line">
            <div class="body-text-small-bold label">
              {{ "profile.appointmentDetails.label.email" | transloco }}
            </div>

            <div class="body-text wrap-anywhere">
              {{ locationDetailDto.contact.emailAddress }}
            </div>
          </div>

          <div class="info-line">
            <div class="body-text-small-bold label">
              {{ "profile.appointmentDetails.label.therapist" | transloco }}
            </div>

            <div class="body-text">
              {{ appointmentDto.employeeName }}
            </div>
          </div>
        </div>
      </div>
    }

    @if (appointmentHistory.length > 0) {
      <div class="column">
        <div class="body-text-bold">{{ "profile.appointmentDetails.label.history" | transloco }}</div>
        @for (history of appointmentHistory; track history) {
          <div class="history-card">
            <mat-icon class="cancelled">block</mat-icon>
            <div class="body-text-small-bold cancelled flex">{{
                "profile.appointmentDetails.label.historyText" | transloco: {
                  date: (history.actionDate |
                    customDate:'dd.MM.yyyy HH:mm')
                }
              }}
            </div>
            <div class="body-text-small cancelled">{{ history.actionDate | customDate:'dd.MM.yyyy' }}</div>
          </div>
        }
      </div>
    }

    <div class="actions">
      @if (appointmentDto.isDeleted) {
        <app-text-button (click)="hide()" [text]="'profile.appointmentDetails.button.hide' | transloco" colorVariant="cancelled" leadingIcon="visibility_on" type="rounded"></app-text-button>
      } @else {
        <app-text-button (click)="cancel()" [text]="'profile.appointmentDetails.button.cancel' | transloco" colorVariant="cancelled" leadingIcon="delete" type="rounded"></app-text-button>
      }
    </div>
  </div>
}
